import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import PoweredByButton from "../components/web-layout/powered-by-button";
import Header from "./header";

export default function ProjectPowerEnrollment() {
    const [showForm, setShowForm] = useState(false);
    const { t, i18n } = useTranslation();

    return (
        <div className="h-screen bg-white-transparent">
            <script
                type="text/javascript"
                src="https://hipaa.jotform.com/jsform/222413302827447"
            />
            {showForm ? (
                <iframe
                    title="ADA - Project Power"
                    src={`https://hipaa.jotform.com/form/222413302827447?language=${i18n.language}`}
                    allow="geolocation; microphone; camera"
                    allowFullScreen
                    name="222413302827447"
                    id="222413302827447"
                    className="iframe-screen width-10px min-width-100p overflow-hidden border-none display-block"
                    scrolling="no"
                />
            ) : (
                <>
                    <Header />
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12 col-md-8 offset-md-2">
                                <div
                                    id="comp-l8uqoa9o"
                                    className="ppe-header"
                                    data-testid="richTextElement"
                                >
                                    <h5 className="font_5 font-size-35 text-align-center">
                                        <span className="font-size-35">
                                            <span className="font-weight-bold">
                                                <span
                                                    style={{
                                                        fontFamily:
                                                            "roboto-thin,roboto,sans-serif",
                                                    }}
                                                >
                                                    {t("ada_jotform_header")}
                                                </span>
                                            </span>
                                        </span>
                                    </h5>
                                </div>
                                <div
                                    id="comp-l8uqrbwm"
                                    className="text-align-start overflow-wrap-break-word pointer-events-none "
                                    data-testid="richTextElement"
                                >
                                    <p className="text-align-center letter-spacing-0em font-size-18">
                                        <span className="font-size-18">
                                            <span
                                                style={{
                                                    fontFamily:
                                                        "roboto-thin,roboto,sans-serif",
                                                }}
                                            >
                                                {t("ada_jotform_body")}
                                            </span>
                                        </span>
                                    </p>
                                </div>
                                <PoweredByButton />
                                <div className="row justify-content-center mt-4">
                                    <Button
                                        variant="primary"
                                        size="lg"
                                        className="ada-btn-success text-align-center margin-left-10p margin-right-10p"
                                        block
                                        onClick={() => {
                                            setShowForm(true);
                                        }}
                                    >
                                        <span className="project-powerby-button">
                                            {t("ada_jotform_submit")}
                                            <svg
                                                data-bbox="9.9 72 180.2 56"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="60"
                                                height="40"
                                                viewBox="60 10 100 200"
                                                data-type="shape"
                                            >
                                                <g>
                                                    <path d="M9.9 96v7.6h158l-27.8 15.9-3.3 1.9 3.7 6.6 3.3-1.9 40.4-23.1 5.9-3.4-5.9-3.3-40.8-22.5-3.3-1.8-3.7 6.7 3.4 1.8 28 15.5H9.9z" />
                                                </g>
                                            </svg>
                                        </span>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}
